import MarkerWrapper from './MarkerWrapper';

import './AddressMarker.sass';

import UntitledIcon from '@payaca/untitled-icons';

type Props = {
  onClick?: () => void;
  lat: number; // required for positioning
  lng: number; // required for positioning
};
const AddressMarker = ({ onClick }: Props) => {
  return (
    <MarkerWrapper onClick={onClick} className="address-marker">
      <div className="address-indicator">
        <UntitledIcon name="home-02.3" />
      </div>
      <div className="triangle" />
    </MarkerWrapper>
  );
};
export default AddressMarker;
